import {RecordsFilter} from 'core/History';

export function filterHistory(history: HistoryLog, ...filters: RecordsFilter[]): HistoryLog {
  return filters.reduce((processedHistory, currentFilter) => {
    return processedHistory.filter(currentFilter);
  }, history);
}
